import FluffyButton from '@gotamedia/fluffy/Button'
import { themeHelpers } from '@gotamedia/fluffy/utils/theme'

import styled, { css } from 'styled-components'

const Headline = styled.h2`
    font-size: 16px;
    font-family: 'Sanomat Sans Text';
    font-weight: 700;
    padding: 12px;
`

const Container = styled.div`
    display: flex;
    flex-direction: column;
    border-top: 4px solid;
    background-color: #f5f5f5;
    border-color:  ${({ theme }) => theme.colors.brand};
`

const Wrapper = styled.div`
    display: flex;
    margin: auto;
    flex-direction: row;
`

const ContainerWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    overflow-x: hidden;
    ${themeHelpers.isNotLargeDevice(css`
        flex-direction: column;
        align-items: center;
    `)}
`

const Anchor = styled.a`
    width: auto;
    margin: 0 auto;
`

const InfoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    justify-items: center;
    height: 80%;
    width: auto;
    padding: 12px;
    min-width: 280px;
    max-width: 280px;

    ${themeHelpers.isNotLargeDevice(css`
        width: 100%;
        align-items: center;
        height: auto;
        padding-top: 0;
    `)}
`

const SubHeadline = styled.h3`
    font-size: 16px;
    font-family: 'Sanomat Sans Text';
    font-weight: 700;
    text-align: center;
    width: 100%;
    margin-bottom: 8px;
`
const ButtonLink = styled(FluffyButton)`
    width: auto;
    font-family: "Sanomat Sans Text";
    font-size: 14px;
`

export {
    Anchor,
    Headline,
    Container,
    Wrapper,
    InfoWrapper,
    SubHeadline,
    ButtonLink,
    ContainerWrapper
}